var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13H13C13.2761 13 13.5 13.2239 13.5 13.5C13.5 13.7455 13.3231 13.9496 13.0899 13.9919L13 14H8C7.72386 14 7.5 13.7761 7.5 13.5C7.5 13.2545 7.67688 13.0504 7.91012 13.0081L8 13H13H8ZM6 9H15C15.2761 9 15.5 9.22386 15.5 9.5C15.5 9.74546 15.3231 9.94961 15.0899 9.99194L15 10H6C5.72386 10 5.5 9.77614 5.5 9.5C5.5 9.25454 5.67688 9.05039 5.91012 9.00806L6 9H15H6ZM4 5H17C17.2761 5 17.5 5.22386 17.5 5.5C17.5 5.74546 17.3231 5.94961 17.0899 5.99194L17 6H4C3.72386 6 3.5 5.77614 3.5 5.5C3.5 5.25454 3.67688 5.05039 3.91012 5.00806L4 5H17H4Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.11d81108d9350cd7cd2063267f65cbba.svg";
export { ForwardRef as ReactComponent };